/**
 * description 采编中心-我的、网站渠道-基础编辑器多图上传弹窗控制器
 * created by he.zhikai
 * created on 2017-08-16
 */
'use strict';
angular.module('basicUploadPicturesModule', []).controller('basicUploadPicturesCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$templateRequest',
    '$timeout',
    '$validation',
    'modalDialog',
    'trsHttpService',
    'personalFileService',
    'imgInfo',
    'globleParamsSet',
    'getFileMD5Service',
    function($scope, $q, $modalInstance, $templateRequest, $timeout, $validation, modalDialog, trsHttpService, personalFileService, imgInfo, globleParamsSet, getFileMD5Service) {
        initStatus();
        initData();

        /**
         * [initStatus description] 图片加载失败的时候，给data新增一个标志。
         * @return {[type]} [description]
         */
        window.showPic = function(img) {
            img.src = 'https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=59285992,513800291&fm=26&gp=0.jpg';
            img.onerror = null; // 当请求的默认图片不存在的时候不会一直的跳动，循环加载
            let box = document.createElement('div');
            box.title = '图片加载失败，不能选中所示图片';
            box.className = 'ac';
            box.onclick = function(e) {
                e.stopPropagation();
            };
            img.parentNode.parentNode.append(box);
        };

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                navs: [
                    {
                        name: '我的图片',
                        value: '1',
                    },
                    {
                        name: '本地上传',
                        value: '2',
                    },
                ],
                floatTypes: [
                    {
                        name: '无浮动',
                        value: '1',
                    },
                    {
                        name: '左浮动',
                        value: '2',
                    },
                    {
                        name: '右浮动',
                        value: '3',
                    },
                    {
                        name: '居中独占一行',
                        value: '4',
                    },
                ],
                insertPicture: {
                    url: '',
                    width: '',
                    height: '',
                    border: '',
                    margin: '',
                    description: '',
                },
                scale: 1, // 宽高比例
                picList: [],
                myPictures: [{}], // 我的图片列表
                selectedArray: [], // 我的图片选中图片
                currFileId: '0', // 当前文件夹的id
                keywords: '', // 检索关键词
                uploadImgs: [],
                uploadedSrcs: [],
                progress: {},
                localPic: [],
                PersonalMaterialOfImgs: [],
            };
            $scope.page = {
                ITEMCOUNT: '0',
                CURRPAGE: '1',
                PAGESIZE: '18',
                PAGECOUNT: '1',
            };
            $scope.status = {
                selected: true, // true表示图片成功加载，false表示图片加载失败
                showDeleteIcon: false,
                pictureScaling: false,
                maxSize: 30, // 单图最大尺寸 单位MB
                scaleWidth: 700, // 缩放宽度
                isAddPersonalMaterial: true,
                fudong: {
                    '1': 'icon-wufudong',
                    '2': 'icon-zuofudong',
                    '3': 'icon-youfudong',
                    '4': 'icon-juzhong',
                },
            };
            $scope.params = {
                serviceid: 'mlf_releaseSource', // 服务名
                methodname: 'queryPersonalMaterials', // 方法名
                PersonalMaterialId: '0', // 主键，唯一性
                status: '0', // 正常
                fileType: '2', // 数据类型
                order: '0', // 0：按创建时间排序，1：显示名称排序
                searchValue: '', // 搜索内容
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.data.selectedNav = $scope.data.navs[0];
            $scope.data.selectedFloat = $scope.data.floatTypes[0];
            initFileMaxSize();
            initInputFile();
            if (angular.isDefined(imgInfo)) {
                initImgInfo();
            }
        }

        function initData() {
            requestData();
            getFileMD5Service.init();
        }

        /**
         * [requestData description] 请求我的图片数据
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                // 9080
                $scope.data.myPictures = data.DATA;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT; // 页数
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT; // 文件数量
                getFileRoutes();
            });
        }

        /**
         * [requestData description] 请求我的图片数据
         * @return {[type]} [description]
         */
        // $scope.getAutoHeight = function() {
        //     $timeout(function() {
        //         var bodyHeight = $(".publicModal .body").height(),
        //             fixedAreaHeight = $(".fixedArea").height();
        //         var contentHeight = bodyHeight - fixedAreaHeight;
        //         $(".content-pic.uploadContent").height(contentHeight);
        //     }, 500);
        // };
        /**
         * [finish description] 完成
         * @return {[type]} [description]
         */
        $scope.finish = function() {
            // $scope.status.lockBtn = true;
            var selectedPic = [];
            for (var i = 0; i < $scope.data.uploadImgs.length; i++) {
                if ($scope.data.uploadImgs[i].isSelected) {
                    selectedPic.push($scope.data.uploadImgs[i]);
                }
            }
            if (selectedPic.length === 0) {
                var data = [];
                addMyPictures(data);
            } else {
                $scope.data.uploadImgs = selectedPic;
                // $scope.data.uploadImgs = $scope.data.localPic;
                $scope.theFinish();
            }
        };

        /**
         * [isAddPersonalMaterial description]是否保存至个人素材库
         * @return {Boolean} [description]
         */
        $scope.isAddPersonalMaterial = function() {
            $scope.status.isAddPersonalMaterial = !$scope.status.isAddPersonalMaterial;
        };

        /**
         * [getFileRoutes description] 获取当前文件的导航
         * @return {[type]} [description]
         */
        function getFileRoutes() {
            if ($scope.data.currFileId == '0') {
                $scope.status.isShowRoutes = false;
                return;
            } else {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'getPersonalMaterialDaoHang',
                    PersonalMaterialId: $scope.data.currFileId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var tempArray = [];
                    var ellipsisTitle = '';
                    // 导航长度大于3时，截取中间部分的导航串
                    for (var i = data.length - 1; i >= 0; i--) {
                        if (data.length > 3 && i < data.length && i > 0) {
                            ellipsisTitle += i == data.length - 1 ? data[i].FILEDESC : '>' + data[i].FILEDESC;
                        }
                        data[i].fileTitle = data[i].FILEDESC;
                        tempArray.push(data[i]);
                    }
                    // 添加根目录
                    $scope.data.routes = [
                        {
                            FILEDESC: '全部文件',
                            PERSONALMATERIALID: '0',
                            fileTitle: '全部文件',
                        },
                    ].concat(tempArray);
                    $scope.data.allRoutes = angular.copy($scope.data.routes);
                    $scope.status.isShowRoutes = true;
                    var num = 0;
                    var last = false;
                    adjustWidth(num, last); // 若路径宽度超出最大宽度500px则调整
                });
            }
        }

        // 若路径宽度超出最大宽度500px则调整
        function adjustWidth(num, last) {
            $timeout(function() {
                if (angular.element('.searchBreadNav').width() > 500) {
                    if (num == $scope.data.routes.length - 1 && !last) {
                        // 如果前面几个路径省略后宽度依然超出，则缩短最后一个
                        $scope.data.routes[num].FILEDESC = $scope.data.routes[num].FILEDESC.substring(0, 5) + '...';
                        last = true;
                        adjustWidth(num, last);
                    }
                    if (num > $scope.data.routes.length - 1) {return;}
                    $scope.data.routes[num].FILEDESC = '...';
                    if (num == $scope.data.routes.length - 1) {
                        num = $scope.data.routes.length - 1;
                        var mergenum = 1;
                        mergeBreadnav(mergenum);
                        return;
                    } else {
                        num++;
                    }
                    adjustWidth(num, last);
                } else {
                    return;
                }
            }, 20);
        }

        function mergeBreadnav(mergenum) {
            $timeout(function() {
                if (angular.element('.searchBreadNav').width() > 500) {
                    var tempArray = [];
                    var ellipsisTitle = '',
                        materialid = '';
                    var data = $scope.data.routes;
                    if (data.length === 1) {return;}
                    if (data.length === 2) {
                        for (var i = 0; i < mergenum + 1; i++) {
                            ellipsisTitle += data[i].fileTitle + '>';
                            materialid += data[i].PERSONALMATERIALID + ',';
                        }
                        materialid = materialid.substring(0, materialid.length - 1);
                    } else {
                        for (var i = 0; i < mergenum + 1; i++) {
                            ellipsisTitle += data[i].fileTitle + '>';
                        }
                    }
                    ellipsisTitle = ellipsisTitle.substring(0, ellipsisTitle.length - 1);
                    $scope.data.routes.splice(0, mergenum + 1, {
                        // 点击...的时候调到根目录
                        FILEDESC: '... ...',
                        PERSONALMATERIALID: $scope.data.routes.length === 2 ? materialid : $scope.data.routes[mergenum].PERSONALMATERIALID,
                        fileTitle: ellipsisTitle,
                    });
                    mergeBreadnav(mergenum);
                } else {
                    return;
                }
            }, 20);
        }

        /**
         * [turnBackToPreviousRoute description] 返回上一级目录
         * @return {[type]} [description]
         */
        $scope.turnBackToPreviousRoute = function(currentRoute) {
            var routesLength = $scope.data.routes.length;
            var route;
            if (routesLength === 1) {
                // 在路径被合并为一条的时候
                var allId = $scope.data.routes[0].PERSONALMATERIALID.split(','),
                    lastPERSONALMATERIALID = allId[allId.length - 2];
                route = {
                    PERSONALMATERIALID: lastPERSONALMATERIALID, // 把上一条的id存起来
                };
            } else {
                route = $scope.data.routes[routesLength - 2];
            }
            var lastRoute = $scope.data.routes[routesLength - 1];
            if (currentRoute == 0) {
                turnBack(route);
            } else if (lastRoute.PERSONALMATERIALID != currentRoute.PERSONALMATERIALID) {
                turnBack(currentRoute);
            }
        };

        /**
         * [turnBackToAllFile description] 返回全部文件
         * @return {[type]} [description]
         */
        $scope.turnBackToAllFile = function() {
            var route = $scope.data.routes[0];
            turnBack(route);
        };

        /**
         * [turnBack description] 返回指定目录
         * @param  {[type]} route [description] 指定目录
         * @return {[type]}       [description]
         */
        function turnBack(route) {
            $scope.params.searchValue = '';
            $scope.data.keyWords = $scope.data.keywords = '';
            $scope.params.PersonalMaterialId = route.PERSONALMATERIALID;
            $scope.data.currFileId = route.PERSONALMATERIALID;
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            requestData();
        }

        /**
         * [search description] 搜索
         * @param  {[type]} ev [description] 键盘按键
         * @return {[type]}    [description]
         */
        $scope.search = function(ev) {
            // if ((angular.isDefined(ev) && ev.keyCode == 13) || ev == 1) {
            var num = 0;
            var last = false;
            adjustWidth(num, last);
            $scope.params.searchValue = angular.copy($scope.data.keywords);
            $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
            $scope.status.copyCurrPage = 1;
            $scope.data.keyWords = $scope.data.keywords;
            requestData();
            // }
        };

        /**
         * [changeNav description] 切换标签
         * @param  {[type]} nav [description] 标签数据
         * @return {[type]}    [description]
         */
        $scope.changeNav = function(nav) {
            $scope.data.selectedNav = nav;
            $scope.data.keyWords = $scope.data.keywords = '';
            if (nav.value == '2') {
                getContentHeight();
            }
        };

        /**
         * [selectDoc description] 单选
         * @param  {[type]} item [description] 选中的文件
         * @return {[type]}      [description]
         */
        // 列表单选框 点击选中
        $scope.selectDoc = function(item, e) {
            // e.stopPropagation();
            // FILESIZE不等于0，是为了排除掉文件夹
            if ($scope.data.selectedArray.indexOf(item) < 0 && item.FILESIZE != '0') {
                $scope.data.selectedArray.push(item);
            } else if ($scope.data.selectedArray.indexOf(item) >= 0 && item.FILESIZE != '0') {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findChildrenFile = function(item) {
            if (item.FILETYPE == '0') {
                $scope.params.searchValue = '';
                $scope.params.PersonalMaterialId = item.PERSONALMATERIALID;
                $scope.data.currFileId = item.PERSONALMATERIALID;
                $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.copyCurrPage = 1;
                $scope.data.keyWords = $scope.data.keywords = '';
                requestData();
            }
        };

        /**
         * [showDefaultPic description] 加载默认图片
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDefaultPic = function(img) {
            console.log(555);
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            // $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
            $('.uploadRsource .body').animate({ scrollTop: 0 }, 'fast');
        };

        /**
         * [initFileMaxSize description] 获取图片上传最大尺寸限制
         * @return {[type]} [description]
         */
        function initFileMaxSize() {
            $scope.status.maxSize = 30;
            return;
        }

        /**
         * [initInputFile description] 初始化文件上传
         * @return {[type]} [description]
         */
        function initInputFile() {
            $scope.status.file = $(document.createElement('input'));
            $scope.status.file.attr({
                type: 'file',
                name: 'file',
                class: 'webuploader-element-invisible',
                multiple: 'file',
                accept: '.gif,.jpg,.jpeg,.bmp,.png,.webp,.eps',
            });
            $scope.status.file[0].onchange = function() {
                var self = this;
                $timeout(function() {
                    for (var i = 0; i < self.files.length; i++) {
                        if (self.files[i].type.split('/')[0] == 'image' || self.files[i].type == 'application/postscript') {
                            angular.copy($scope.data.picList.push(self.files[i]));
                        } else {
                            modalDialog.alertType('请上传符合格式要求的文件', '', 'error', 'confirm');
                        }
                        getContentHeight();
                    }
                    $scope.uploadPics();
                    $timeout(function() {
                        // 如框内高度不够显示图片，则新上传的图片将老图片往上顶
                        var height = $('.basic-upload-pictures')
                            .find('.pic-items')
                            .height();
                        $('.basic-upload-pictures')
                            .find('.pic-content')
                            .scrollTop(height);
                    });
                    initInputFile();
                });
            };
        }

        /**
         * [getContentHeight description] 控制content内容的高度
         * @return {[type]} [description]
         */
        function getContentHeight() {
            $timeout(function() {
                if ($scope.data.picList.length == 0) {
                    var hei;
                    var bodyHei = $('.publicModal .body').height();
                    hei = bodyHei - $('.fixedArea').height();
                    $('.uploadContent.localUpload').css({ height: hei + 'px' });
                } else {
                    $('.uploadContent.localUpload').css({ height: 'auto' });
                }
            });
        }

        /**
         * [initImgInfo description] 初始化图片信息
         * @return {[type]} [description]
         */
        function initImgInfo() {
            var imgNode = $(imgInfo);
            var img = new Image();
            img.src = imgNode.attr('src');
            img.onload = function() {
                $scope.data.uploadpic = imgNode.attr('uploadpic');
                $scope.data.insertPicture = {
                    url: imgNode.attr('src'),
                    width: parseInt(imgNode.attr('width')) || this.width,
                    height: parseInt(imgNode.attr('height')) || this.height,
                    border: parseInt(imgNode.attr('border')) || 0,
                    margin: parseInt(imgNode.attr('vspace')) || 0,
                    description: imgNode.attr('title') || '',
                };
            };
            img.onerror = function() {
                $scope.data.insertPicture = {
                    url: imgNode.attr('src'),
                    width: parseInt(imgNode.attr('width')) || '',
                    height: parseInt(imgNode.attr('height')) || '',
                    border: parseInt(imgNode.attr('border')) || 0,
                    margin: parseInt(imgNode.attr('vspace')) || 0,
                    description: imgNode.attr('title') || '',
                };
            };
        }

        /* 插入图片部分开始*/
        /**
         * [scalingCheck description] 固定比例确认框
         * @return {[type]} [description]
         */
        $scope.scalingCheck = function() {
            if (($scope.data.insertPicture.width !== '' && $scope.data.insertPicture.height !== '') || $scope.status.pictureScaling === true) {
                $scope.status.pictureScaling = !$scope.status.pictureScaling;
                if ($scope.status.pictureScaling === true) {
                    $scope.data.scale = $scope.data.insertPicture.width / $scope.data.insertPicture.height || 1;
                }
            }
        };

        /**
         * [description] 监听宽高，保持固定比例
         * @param  {[type]} newValue  [description]
         * @param  {[type]} oldValue) {
         * @return {[type]}           [description]
         */
        $scope.$watch('data.insertPicture.width', function(newValue, oldValue) {
            if ($scope.status.pictureScaling === true) {
                $scope.data.insertPicture.height = newValue === '' ? 0 : newValue / $scope.data.scale;
            }
        });
        $scope.$watch('data.insertPicture.height', function(newValue, oldValue) {
            if ($scope.status.pictureScaling === true) {
                $scope.data.insertPicture.width = newValue === '' ? 0 : newValue * $scope.data.scale;
            }
        });

        /* 插入图片部分结束*/
        /**
         * [cancel 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [chooseLocalPics 上传本地图片]
         * @return {[type]} [description]
         */
        $scope.chooseLocalPics = function() {
            // $("#file")[0].click();
            $scope.status.file[0].click();
        };

        /**
         * [choosePersonalPics description] 从素材库上传
         * @return {[type]} [description]
         */
        $scope.choosePersonalPics = function() {
            personalFileService.openPersonalFile('2', true, function(data) {
                for (var i = 0; i < data.length; i++) {
                    $scope.data.picList.push({
                        previewSrc: data[i].SRCIMGURL,
                        realSrc: data[i].SRCIMGURL,
                        imgName: data[i].FILENAME,
                        imgDesc: data[i].FILEDESC,
                        size: data[i].FILESIZE * 1024,
                        progress: '100%',
                        isPersonalPic: true,
                    });
                }
                $timeout(function() {
                    // 如框内高度不够显示图片，则新上传的图片将老图片往上顶
                    var height = $('.basic-upload-pictures')
                        .find('.pic-items')
                        .height();
                    $('.basic-upload-pictures')
                        .find('.pic-content')
                        .scrollTop(height);
                });
            });
        };

        /**
         * [deletePic 删除图片]
         * @return {[int]} index [description] //删除图片的序号
         */
        $scope.deletePic = function(index) {
            $scope.data.picList.splice(index, 1);
            getContentHeight();
        };

        /**
         * [getPreviewUrl ]获取图片预览地址
         * @params {[object]} item [description] 图片文件对象
         * @return {[type]} [description]
         */
        $scope.getPreviewUrl = function(item) {
            if (!!item.isPersonalPic) {
                return;
            } else {
                item.previewSrc = URL.createObjectURL(item);
            }
        };

        /**
         * [getPicsSize] 获取选中图片的总大小
         * @return {[type]} [description]
         */
        $scope.getPicsSize = function() {
            return (function() {
                var size = 0;
                for (var i = 0; i < $scope.data.picList.length; i++) {
                    size += $scope.data.picList[i].size;
                }
                return Math.round((size / 1024 / 1024) * 100) / 100;
            })();
        };

        /**
         * [uploadPics] 开始上传图片
         * @return {[type]} [description]
         */
        $scope.uploadPics = function() {
            for (let i = 0; i < $scope.data.picList.length; i++) {
                if (angular.isUndefined($scope.data.picList[i].realSrc)) {
                    getFileMD5Service.getMd5($scope.data.picList[i]).then(function(md5) {
                        uploadPic($scope.data.picList[i], md5, i, function(data, index) {
                            // $timeout(function() {
                            $scope.$apply(function() {
                                $scope.data.picList[index].progress = Math.round((data.loaded / data.total) * 100) + '%';
                            });
                            // });
                        },
                        function(data, index) {
                            $scope.$apply(function() {
                                if (angular.isDefined(JSON.parse(data).error)) {
                                    modalDialog.alertType(JSON.parse(data).error, '', 'error', 'confirm');
                                    $scope.data.picList[index].error = JSON.parse(data).error;
                                    return;
                                }
                                $scope.data.picList[index].uploadpic = JSON.parse(data).imgName;
                                $scope.data.picList[index].realSrc = globleParamsSet.dealImgSrcAfterUpload(JSON.parse(data).imgName);
                            });
                        },
                        function(data, index) {
                            $scope.data.picList[index].error = data;
                        },
                        function(data, index) {
                            $scope.data.PersonalMaterialOfImgs[index] = data;
                        });
                    });
                }
            }
        };

        /**
         * [scaleImg] 缩放图片
         * @param {[string]} [imgName] [description] 图片名称
         * @return {[type]} [description]
         */
        function scaleImg(imgName) {
            var deffer = $q.defer();
            var img = new Image();
            img.src = '/wcm/file/read_image.jsp?FileName=' + imgName;
            img.onload = function() {
                var aspectRatio = img.width / img.height;
                var scaleHeight = Math.round($scope.status.scaleWidth / aspectRatio);
                var params = {
                    FILENAME: imgName,
                    FOLDEREXT: 'U0',
                    SCALEHEIGHT: scaleHeight,
                    SCALEWIDTH: $scope.status.scaleWidth,
                    methodname: 'scaleImage',
                    serviceid: 'mlf_image',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    deffer.resolve(data);
                });
            };
            return deffer.promise;
        }

        /**
         * [getAllPercent] 获取总体上传进度
         * @return {[type]} [description]
         */
        $scope.getAllPercent = function() {
            var percent = 0;
            for (var i = 0; i < $scope.data.picList.length; i++) {
                var picFile = $scope.data.picList[i];
                if (picFile.progress !== undefined) {
                    percent += parseFloat(picFile.progress.replace(/%/g, '')) / $scope.data.picList.length;
                }
            }
            $scope.percent = Math.round(percent);
            return Math.round(percent) + '%';
        };

        /**
         * [uploadPic] 上传图片
         * $param {[fn]} onProgress 上传进度回调函数
         * @param {[fn]} onload [description] 上传完成回调函数
         * @return {[type]} [description]
         */
        function uploadPic(fileInfo, md5, index, onProgress, onload, onerror, isPersonal) {
            if (fileInfo.size / 1024 / 1024 > $scope.status.maxSize) {
                onerror('图片不能超过' + $scope.status.maxSize + 'M', index);
                return false;
            }
            var fd = new FormData();
            fd.append('file', fileInfo);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/wcm/openapi/uploadImage?md5=' + md5, true);
            xhr.onload = function(evt) {
                onload(evt.currentTarget.responseText, index);
            };
            xhr.onerror = function(evt) {
                onerror('上传失败，请重新上传', index);
            };
            xhr.upload.onprogress = function(evt) {
                // console.log("进度条");
                // console.log(evt);
                onProgress(evt, index);
            };
            xhr.upload.onloadstart = function() {
                // console.log("开始传了");
            };
            xhr.onreadystatechange = function() {
                // 回调函数
                var status = xhr.readyState;
                if (status == 4 && xhr.status == 200) {
                    var b = JSON.parse(xhr.responseText);
                    isPersonal(b, index);
                }
            };
            xhr.send(fd);
        }

        /**
         * [uploadends] 上传是否正在进行
         * @return {[type]} [description]
         */
        $scope.uploadIsRunning = function() {
            var flag = false;
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if ($scope.data.picList[i].progress !== undefined && $scope.data.picList[i].progress !== '100%') {flag = true;}
            }
            return flag;
        };

        /**
         * [uploadEnd] 是否所有图片上传完成
         * @return {[type]} [description]
         */
        $scope.uploadEnd = function() {
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if ($scope.data.picList[i].realSrc === undefined) {
                    return false;
                }
            }
            return true;
        };

        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var personalImg = $scope.data.selectedArray;
            for (var j = 0; j < personalImg.length; j++) {
                // 我的图片已经选中的
                $scope.data.picList.unshift({
                    previewSrc: personalImg[j].SRCIMGURL,
                    realSrc: personalImg[j].SRCIMGURL,
                    imgName: personalImg[j].FILENAME,
                    imgDesc: personalImg[j].FILEDESC,
                    size: personalImg[j].FILESIZE * 1024,
                    progress: '100%',
                    isPersonalPic: true,
                });
            }
            if ($scope.status.isAddPersonalMaterial == true) {
                var newIsPersonal = new Array();
                var isPersonal = angular.copy($scope.data.PersonalMaterialOfImgs);
                for (var i = 0; i < isPersonal.length; i++) {
                    var obj = {};
                    obj.fileDesc = isPersonal[i].orignalImg;
                    obj.PersonalMaterialId = '0';
                    obj.fileSize = String(isPersonal[i].fileSizeOfKB);
                    obj.fileName = isPersonal[i].imgName;
                    newIsPersonal.push(obj);
                }
                var params = {
                    methodname: 'addPersonalMaterialOfImgs',
                    serviceid: 'mlf_releaseSource',
                    PersonalMaterialOfImgs: JSON.stringify(newIsPersonal),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                });
            }

            resolveImgData();
        };

        /**
         * [处理图片数据]
         */
        function resolveImgData() {
            // 处理图片数据
            var template =
                '<p class="app_image_wrap" type="app_image_wrap">\n' +
                    '<img class="app_image" type="app_image" src="">\n' +
                '</p>\n' +
                '<p class="imagenote" type="imagenote">\n' +
                '</p>';
            var newHtml = '';
            var piclist = $scope.data.picList;
            for (var i = 0; i < piclist.length; i++) {
                if (!angular.isDefined(piclist[i].error)) {
                    var dom = document.createElement('div');
                    dom.innerHTML = template;
                    if (piclist[i].realSrc !== undefined) {
                        var fileInfo = piclist[i];
                        fileInfo.tuShuo = fileInfo.tuShuo === undefined ? '' : fileInfo.tuShuo;
                        var uploadpic = fileInfo.realSrc.split('=')[1];
                        $(dom)
                            .find('.app_image_wrap')
                            .css({
                                textAlign: 'center',
                            });
                        $(dom)
                            .find('img')
                            .attr('src', fileInfo.realSrc);
                        $(dom)
                            .find('img')
                            .attr('uploadpic', uploadpic);
                        $(dom)
                            .find('img')
                            .css({
                                // display: 'block',
                                clear: 'both',
                                maxWidth: 640,
                                // margin: '0 auto',
                            });
                        $(dom)
                            .find('.imagenote')
                            .css({
                                marginTop: 1,
                                paddingTop: 1,
                                fontSize: 14,
                                height: 'auto',
                                color: '#8a939e',
                                paddingBottom: 6,
                                textAlign: 'left',
                                boxSizing: 'initial',
                                lineHeight: '1.5em',
                            });
                        if (fileInfo.tuShuo === '') {
                            $(dom)
                                .find('.imagenote')
                                .html('请输入图片描述');
                        } else {
                            $(dom)
                                .find('.imagenote')
                                .html(fileInfo.tuShuo.replace(/\n/g, '<br/>').replace(/ /g, '　'));
                        }
                    }
                    newHtml += $(dom).html();
                }
            }
            $modalInstance.close(newHtml);
        }
    },
]);
